import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Money } from "../../connect/v2/common/money.js";
import { Address } from "../../connect/v2/resources/address.js";
import { CreditLimitAdjustment } from "./credit_limit_adjustment.js";
import { CreditLimitAdjustmentOffer } from "./credit_limit_adjustment_offer.js";
import { CreditLineRewards } from "./credit_line_rewards.js";
import { CreditLineStatement } from "./credit_line_statement.js";
export const protobufPackage = "squareup.corporate_card.resources";
export let CreditLine_SignedFinanceDisclosure = /* @__PURE__ */ function(CreditLine_SignedFinanceDisclosure) {
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["CL_SFD_DO_NOT_USE"] = 0] = "CL_SFD_DO_NOT_USE";
	/**
	* CALIFORNIA_FINANCE_DISCLOSURE - --
	* @desc SB 1235 Finance Disclosure for businesses based in California
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["CALIFORNIA_FINANCE_DISCLOSURE"] = 1] = "CALIFORNIA_FINANCE_DISCLOSURE";
	/**
	* NEW_YORK_FINANCE_DISCLOSURE - --
	* @desc NY CFDL Finance Disclosure for businesses based in New York
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["NEW_YORK_FINANCE_DISCLOSURE"] = 2] = "NEW_YORK_FINANCE_DISCLOSURE";
	/**
	* FLORIDA_FINANCE_DISCLOSURE - --
	* @desc Florida Finance Disclosure for businesses based in Florida
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["FLORIDA_FINANCE_DISCLOSURE"] = 3] = "FLORIDA_FINANCE_DISCLOSURE";
	/**
	* GEORGIA_FINANCE_DISCLOSURE - --
	* @desc Georgia Finance Disclosure for businesses based in Georgia
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["GEORGIA_FINANCE_DISCLOSURE"] = 4] = "GEORGIA_FINANCE_DISCLOSURE";
	/**
	* KANSAS_FINANCE_DISCLOSURE - --
	* @desc Kansas Finance Disclosure for businesses based in Kansas
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["KANSAS_FINANCE_DISCLOSURE"] = 5] = "KANSAS_FINANCE_DISCLOSURE";
	/**
	* UTAH_FINANCE_DISCLOSURE - --
	* @desc Utah Finance Disclosure for businesses based in Utah
	* --
	*/
	CreditLine_SignedFinanceDisclosure[CreditLine_SignedFinanceDisclosure["UTAH_FINANCE_DISCLOSURE"] = 6] = "UTAH_FINANCE_DISCLOSURE";
	return CreditLine_SignedFinanceDisclosure;
}({});
export let CreditLine_PlatformType = /* @__PURE__ */ function(CreditLine_PlatformType) {
	CreditLine_PlatformType[CreditLine_PlatformType["PT_DO_NOT_USE"] = 0] = "PT_DO_NOT_USE";
	/**
	* INTERNAL - --
	* @desc Internal servicing using the Capital DQ system
	* --
	*/
	CreditLine_PlatformType[CreditLine_PlatformType["INTERNAL"] = 1] = "INTERNAL";
	/**
	* PEACH - --
	* @desc Serviced by Peach (third party Loan Management System) via Loan Gateway and PayOrch
	* --
	*/
	CreditLine_PlatformType[CreditLine_PlatformType["PEACH"] = 2] = "PEACH";
	return CreditLine_PlatformType;
}({});
export let CreditLine_IssuerType = /* @__PURE__ */ function(CreditLine_IssuerType) {
	CreditLine_IssuerType[CreditLine_IssuerType["IT_DO_NOT_USE"] = 0] = "IT_DO_NOT_USE";
	/**
	* I2C - --
	* @desc I2C card issuer
	* --
	*/
	CreditLine_IssuerType[CreditLine_IssuerType["I2C"] = 1] = "I2C";
	/**
	* MQ - --
	* @desc Marqeta card issuer
	* --
	*/
	CreditLine_IssuerType[CreditLine_IssuerType["MQ"] = 2] = "MQ";
	return CreditLine_IssuerType;
}({});
export let CreditLine_AutopaySettings_PaymentAmountType = /* @__PURE__ */ function(CreditLine_AutopaySettings_PaymentAmountType) {
	CreditLine_AutopaySettings_PaymentAmountType[CreditLine_AutopaySettings_PaymentAmountType["PAT_DO_NOT_USE"] = 0] = "PAT_DO_NOT_USE";
	/**
	* STATEMENT_AMOUNT - --
	* @desc The automatic payment will cover the full statement amount
	* --
	*/
	CreditLine_AutopaySettings_PaymentAmountType[CreditLine_AutopaySettings_PaymentAmountType["STATEMENT_AMOUNT"] = 1] = "STATEMENT_AMOUNT";
	/**
	* MIN_PAYMENT - --
	* @desc The automatic payment will only cover the minimum payment
	* --
	*/
	CreditLine_AutopaySettings_PaymentAmountType[CreditLine_AutopaySettings_PaymentAmountType["MIN_PAYMENT"] = 2] = "MIN_PAYMENT";
	return CreditLine_AutopaySettings_PaymentAmountType;
}({});
export let CreditLine_SmartRepaymentSettings_RepaymentBalanceType = /* @__PURE__ */ function(CreditLine_SmartRepaymentSettings_RepaymentBalanceType) {
	CreditLine_SmartRepaymentSettings_RepaymentBalanceType[CreditLine_SmartRepaymentSettings_RepaymentBalanceType["RBT_DO_NOT_USE"] = 0] = "RBT_DO_NOT_USE";
	/**
	* RBT_STATEMENT_BALANCE_PERCENT - --
	* @desc Target a percentage of the statement balance
	* --
	*/
	CreditLine_SmartRepaymentSettings_RepaymentBalanceType[CreditLine_SmartRepaymentSettings_RepaymentBalanceType["RBT_STATEMENT_BALANCE_PERCENT"] = 1] = "RBT_STATEMENT_BALANCE_PERCENT";
	/**
	* RBT_MINIMUM_PAYMENT - --
	* @desc Target the minimum payment amount
	* --
	*/
	CreditLine_SmartRepaymentSettings_RepaymentBalanceType[CreditLine_SmartRepaymentSettings_RepaymentBalanceType["RBT_MINIMUM_PAYMENT"] = 2] = "RBT_MINIMUM_PAYMENT";
	/**
	* RBT_DISABLED - --
	* @desc Smart repayment is disabled
	* --
	*/
	CreditLine_SmartRepaymentSettings_RepaymentBalanceType[CreditLine_SmartRepaymentSettings_RepaymentBalanceType["RBT_DISABLED"] = 3] = "RBT_DISABLED";
	return CreditLine_SmartRepaymentSettings_RepaymentBalanceType;
}({});
export let CreditLine_PaymentAccount_AccountType = /* @__PURE__ */ function(CreditLine_PaymentAccount_AccountType) {
	CreditLine_PaymentAccount_AccountType[CreditLine_PaymentAccount_AccountType["AT_DO_NOT_USE"] = 0] = "AT_DO_NOT_USE";
	/**
	* SQUARE_CHECKING - --
	* @desc The Square Checking account
	* --
	*/
	CreditLine_PaymentAccount_AccountType[CreditLine_PaymentAccount_AccountType["SQUARE_CHECKING"] = 1] = "SQUARE_CHECKING";
	/**
	* EXTERNAL_BANK - --
	* @desc The external bank account
	* --
	*/
	CreditLine_PaymentAccount_AccountType[CreditLine_PaymentAccount_AccountType["EXTERNAL_BANK"] = 2] = "EXTERNAL_BANK";
	return CreditLine_PaymentAccount_AccountType;
}({});
function createBaseCreditLine() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine",
		id: undefined,
		creditLimitMoney: undefined,
		balanceSummary: undefined,
		latestStatement: undefined,
		pendingStatement: undefined,
		holdRateBps: undefined,
		aprBps: undefined,
		autopaySettings: undefined,
		paymentAccounts: [],
		gracePeriodActive: undefined,
		payerEmailAddress: undefined,
		businessAddress: undefined,
		rewards: undefined,
		enabledFeatures: [],
		createdAt: undefined,
		updatedAt: undefined,
		pendingPaymentAmountThresholdReached: undefined,
		financialDisclosures: [],
		businessDisplayName: undefined,
		token: undefined,
		platformType: undefined,
		creditLimitAdjustments: [],
		minPayBps: undefined,
		interestRateBps: undefined,
		productName: undefined,
		closedAt: undefined,
		planStatus: undefined,
		daysPastDue: undefined,
		servicingStatus: undefined,
		creditLimitAdjustmentIncreaseOffer: undefined,
		issuerType: undefined,
		smartRepaymentSettings: undefined
	};
}
export const CreditLine = {
	$type: "squareup.corporate_card.resources.CreditLine",
	encode(message, writer = new BinaryWriter()) {
		if (message.id !== undefined) {
			writer.uint32(10).string(message.id);
		}
		if (message.creditLimitMoney !== undefined) {
			Money.encode(message.creditLimitMoney, writer.uint32(18).fork()).join();
		}
		if (message.balanceSummary !== undefined) {
			CreditLine_BalanceSummary.encode(message.balanceSummary, writer.uint32(74).fork()).join();
		}
		if (message.latestStatement !== undefined) {
			CreditLineStatement.encode(message.latestStatement, writer.uint32(82).fork()).join();
		}
		if (message.pendingStatement !== undefined) {
			CreditLineStatement.encode(message.pendingStatement, writer.uint32(90).fork()).join();
		}
		if (message.holdRateBps !== undefined) {
			writer.uint32(96).int32(message.holdRateBps);
		}
		if (message.aprBps !== undefined) {
			writer.uint32(136).int32(message.aprBps);
		}
		if (message.autopaySettings !== undefined) {
			CreditLine_AutopaySettings.encode(message.autopaySettings, writer.uint32(106).fork()).join();
		}
		for (const v of message.paymentAccounts) {
			CreditLine_PaymentAccount.encode(v, writer.uint32(114).fork()).join();
		}
		if (message.gracePeriodActive !== undefined) {
			writer.uint32(120).bool(message.gracePeriodActive);
		}
		if (message.payerEmailAddress !== undefined) {
			writer.uint32(130).string(message.payerEmailAddress);
		}
		if (message.businessAddress !== undefined) {
			Address.encode(message.businessAddress, writer.uint32(146).fork()).join();
		}
		if (message.rewards !== undefined) {
			CreditLineRewards.encode(message.rewards, writer.uint32(154).fork()).join();
		}
		for (const v of message.enabledFeatures) {
			writer.uint32(162).string(v);
		}
		if (message.createdAt !== undefined) {
			writer.uint32(58).string(message.createdAt);
		}
		if (message.updatedAt !== undefined) {
			writer.uint32(66).string(message.updatedAt);
		}
		if (message.pendingPaymentAmountThresholdReached !== undefined) {
			writer.uint32(168).bool(message.pendingPaymentAmountThresholdReached);
		}
		for (const v of message.financialDisclosures) {
			writer.uint32(176).int32(v);
		}
		if (message.businessDisplayName !== undefined) {
			writer.uint32(186).string(message.businessDisplayName);
		}
		if (message.token !== undefined) {
			writer.uint32(194).string(message.token);
		}
		if (message.platformType !== undefined) {
			writer.uint32(200).int32(message.platformType);
		}
		for (const v of message.creditLimitAdjustments) {
			CreditLimitAdjustment.encode(v, writer.uint32(218).fork()).join();
		}
		if (message.minPayBps !== undefined) {
			writer.uint32(224).int32(message.minPayBps);
		}
		if (message.interestRateBps !== undefined) {
			writer.uint32(232).int32(message.interestRateBps);
		}
		if (message.productName !== undefined) {
			writer.uint32(242).string(message.productName);
		}
		if (message.closedAt !== undefined) {
			writer.uint32(250).string(message.closedAt);
		}
		if (message.planStatus !== undefined) {
			writer.uint32(256).int32(message.planStatus);
		}
		if (message.daysPastDue !== undefined) {
			writer.uint32(264).int32(message.daysPastDue);
		}
		if (message.servicingStatus !== undefined) {
			writer.uint32(274).string(message.servicingStatus);
		}
		if (message.creditLimitAdjustmentIncreaseOffer !== undefined) {
			CreditLimitAdjustmentOffer.encode(message.creditLimitAdjustmentIncreaseOffer, writer.uint32(282).fork()).join();
		}
		if (message.issuerType !== undefined) {
			writer.uint32(288).int32(message.issuerType);
		}
		if (message.smartRepaymentSettings !== undefined) {
			CreditLine_SmartRepaymentSettings.encode(message.smartRepaymentSettings, writer.uint32(298).fork()).join();
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 10) {
						break;
					}
					message.id = reader.string();
					continue;
				}
				case 2: {
					if (tag !== 18) {
						break;
					}
					message.creditLimitMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 9: {
					if (tag !== 74) {
						break;
					}
					message.balanceSummary = CreditLine_BalanceSummary.decode(reader, reader.uint32());
					continue;
				}
				case 10: {
					if (tag !== 82) {
						break;
					}
					message.latestStatement = CreditLineStatement.decode(reader, reader.uint32());
					continue;
				}
				case 11: {
					if (tag !== 90) {
						break;
					}
					message.pendingStatement = CreditLineStatement.decode(reader, reader.uint32());
					continue;
				}
				case 12: {
					if (tag !== 96) {
						break;
					}
					message.holdRateBps = reader.int32();
					continue;
				}
				case 17: {
					if (tag !== 136) {
						break;
					}
					message.aprBps = reader.int32();
					continue;
				}
				case 13: {
					if (tag !== 106) {
						break;
					}
					message.autopaySettings = CreditLine_AutopaySettings.decode(reader, reader.uint32());
					continue;
				}
				case 14: {
					if (tag !== 114) {
						break;
					}
					message.paymentAccounts.push(CreditLine_PaymentAccount.decode(reader, reader.uint32()));
					continue;
				}
				case 15: {
					if (tag !== 120) {
						break;
					}
					message.gracePeriodActive = reader.bool();
					continue;
				}
				case 16: {
					if (tag !== 130) {
						break;
					}
					message.payerEmailAddress = reader.string();
					continue;
				}
				case 18: {
					if (tag !== 146) {
						break;
					}
					message.businessAddress = Address.decode(reader, reader.uint32());
					continue;
				}
				case 19: {
					if (tag !== 154) {
						break;
					}
					message.rewards = CreditLineRewards.decode(reader, reader.uint32());
					continue;
				}
				case 20: {
					if (tag !== 162) {
						break;
					}
					message.enabledFeatures.push(reader.string());
					continue;
				}
				case 7: {
					if (tag !== 58) {
						break;
					}
					message.createdAt = reader.string();
					continue;
				}
				case 8: {
					if (tag !== 66) {
						break;
					}
					message.updatedAt = reader.string();
					continue;
				}
				case 21: {
					if (tag !== 168) {
						break;
					}
					message.pendingPaymentAmountThresholdReached = reader.bool();
					continue;
				}
				case 22: {
					if (tag === 176) {
						message.financialDisclosures.push(reader.int32());
						continue;
					}
					if (tag === 178) {
						const end2 = reader.uint32() + reader.pos;
						while (reader.pos < end2) {
							message.financialDisclosures.push(reader.int32());
						}
						continue;
					}
					break;
				}
				case 23: {
					if (tag !== 186) {
						break;
					}
					message.businessDisplayName = reader.string();
					continue;
				}
				case 24: {
					if (tag !== 194) {
						break;
					}
					message.token = reader.string();
					continue;
				}
				case 25: {
					if (tag !== 200) {
						break;
					}
					message.platformType = reader.int32();
					continue;
				}
				case 27: {
					if (tag !== 218) {
						break;
					}
					message.creditLimitAdjustments.push(CreditLimitAdjustment.decode(reader, reader.uint32()));
					continue;
				}
				case 28: {
					if (tag !== 224) {
						break;
					}
					message.minPayBps = reader.int32();
					continue;
				}
				case 29: {
					if (tag !== 232) {
						break;
					}
					message.interestRateBps = reader.int32();
					continue;
				}
				case 30: {
					if (tag !== 242) {
						break;
					}
					message.productName = reader.string();
					continue;
				}
				case 31: {
					if (tag !== 250) {
						break;
					}
					message.closedAt = reader.string();
					continue;
				}
				case 32: {
					if (tag !== 256) {
						break;
					}
					message.planStatus = reader.int32();
					continue;
				}
				case 33: {
					if (tag !== 264) {
						break;
					}
					message.daysPastDue = reader.int32();
					continue;
				}
				case 34: {
					if (tag !== 274) {
						break;
					}
					message.servicingStatus = reader.string();
					continue;
				}
				case 35: {
					if (tag !== 282) {
						break;
					}
					message.creditLimitAdjustmentIncreaseOffer = CreditLimitAdjustmentOffer.decode(reader, reader.uint32());
					continue;
				}
				case 36: {
					if (tag !== 288) {
						break;
					}
					message.issuerType = reader.int32();
					continue;
				}
				case 37: {
					if (tag !== 298) {
						break;
					}
					message.smartRepaymentSettings = CreditLine_SmartRepaymentSettings.decode(reader, reader.uint32());
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine();
		message.id = object.id ?? undefined;
		message.creditLimitMoney = object.creditLimitMoney !== undefined && object.creditLimitMoney !== null ? Money.fromPartial(object.creditLimitMoney) : undefined;
		message.balanceSummary = object.balanceSummary !== undefined && object.balanceSummary !== null ? CreditLine_BalanceSummary.fromPartial(object.balanceSummary) : undefined;
		message.latestStatement = object.latestStatement !== undefined && object.latestStatement !== null ? CreditLineStatement.fromPartial(object.latestStatement) : undefined;
		message.pendingStatement = object.pendingStatement !== undefined && object.pendingStatement !== null ? CreditLineStatement.fromPartial(object.pendingStatement) : undefined;
		message.holdRateBps = object.holdRateBps ?? undefined;
		message.aprBps = object.aprBps ?? undefined;
		message.autopaySettings = object.autopaySettings !== undefined && object.autopaySettings !== null ? CreditLine_AutopaySettings.fromPartial(object.autopaySettings) : undefined;
		message.paymentAccounts = object.paymentAccounts?.map((e) => CreditLine_PaymentAccount.fromPartial(e)) || [];
		message.gracePeriodActive = object.gracePeriodActive ?? undefined;
		message.payerEmailAddress = object.payerEmailAddress ?? undefined;
		message.businessAddress = object.businessAddress !== undefined && object.businessAddress !== null ? Address.fromPartial(object.businessAddress) : undefined;
		message.rewards = object.rewards !== undefined && object.rewards !== null ? CreditLineRewards.fromPartial(object.rewards) : undefined;
		message.enabledFeatures = object.enabledFeatures?.map((e) => e) || [];
		message.createdAt = object.createdAt ?? undefined;
		message.updatedAt = object.updatedAt ?? undefined;
		message.pendingPaymentAmountThresholdReached = object.pendingPaymentAmountThresholdReached ?? undefined;
		message.financialDisclosures = object.financialDisclosures?.map((e) => e) || [];
		message.businessDisplayName = object.businessDisplayName ?? undefined;
		message.token = object.token ?? undefined;
		message.platformType = object.platformType ?? undefined;
		message.creditLimitAdjustments = object.creditLimitAdjustments?.map((e) => CreditLimitAdjustment.fromPartial(e)) || [];
		message.minPayBps = object.minPayBps ?? undefined;
		message.interestRateBps = object.interestRateBps ?? undefined;
		message.productName = object.productName ?? undefined;
		message.closedAt = object.closedAt ?? undefined;
		message.planStatus = object.planStatus ?? undefined;
		message.daysPastDue = object.daysPastDue ?? undefined;
		message.servicingStatus = object.servicingStatus ?? undefined;
		message.creditLimitAdjustmentIncreaseOffer = object.creditLimitAdjustmentIncreaseOffer !== undefined && object.creditLimitAdjustmentIncreaseOffer !== null ? CreditLimitAdjustmentOffer.fromPartial(object.creditLimitAdjustmentIncreaseOffer) : undefined;
		message.issuerType = object.issuerType ?? undefined;
		message.smartRepaymentSettings = object.smartRepaymentSettings !== undefined && object.smartRepaymentSettings !== null ? CreditLine_SmartRepaymentSettings.fromPartial(object.smartRepaymentSettings) : undefined;
		return message;
	}
};
function createBaseCreditLine_BalanceSummary() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine.BalanceSummary",
		totalBalanceMoney: undefined,
		currentMonthBalanceMoney: undefined,
		statementBalanceMoney: undefined,
		minimumPaymentBalanceMoney: undefined,
		pastDueBalanceMoney: undefined,
		availableBalanceMoney: undefined,
		outstandingInterestBalanceMoney: undefined,
		outstandingPrincipalBalanceMoney: undefined
	};
}
export const CreditLine_BalanceSummary = {
	$type: "squareup.corporate_card.resources.CreditLine.BalanceSummary",
	encode(message, writer = new BinaryWriter()) {
		if (message.totalBalanceMoney !== undefined) {
			Money.encode(message.totalBalanceMoney, writer.uint32(10).fork()).join();
		}
		if (message.currentMonthBalanceMoney !== undefined) {
			Money.encode(message.currentMonthBalanceMoney, writer.uint32(18).fork()).join();
		}
		if (message.statementBalanceMoney !== undefined) {
			Money.encode(message.statementBalanceMoney, writer.uint32(26).fork()).join();
		}
		if (message.minimumPaymentBalanceMoney !== undefined) {
			Money.encode(message.minimumPaymentBalanceMoney, writer.uint32(34).fork()).join();
		}
		if (message.pastDueBalanceMoney !== undefined) {
			Money.encode(message.pastDueBalanceMoney, writer.uint32(42).fork()).join();
		}
		if (message.availableBalanceMoney !== undefined) {
			Money.encode(message.availableBalanceMoney, writer.uint32(50).fork()).join();
		}
		if (message.outstandingInterestBalanceMoney !== undefined) {
			Money.encode(message.outstandingInterestBalanceMoney, writer.uint32(58).fork()).join();
		}
		if (message.outstandingPrincipalBalanceMoney !== undefined) {
			Money.encode(message.outstandingPrincipalBalanceMoney, writer.uint32(66).fork()).join();
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine_BalanceSummary();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 10) {
						break;
					}
					message.totalBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 2: {
					if (tag !== 18) {
						break;
					}
					message.currentMonthBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 3: {
					if (tag !== 26) {
						break;
					}
					message.statementBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 4: {
					if (tag !== 34) {
						break;
					}
					message.minimumPaymentBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 5: {
					if (tag !== 42) {
						break;
					}
					message.pastDueBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 6: {
					if (tag !== 50) {
						break;
					}
					message.availableBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 7: {
					if (tag !== 58) {
						break;
					}
					message.outstandingInterestBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
				case 8: {
					if (tag !== 66) {
						break;
					}
					message.outstandingPrincipalBalanceMoney = Money.decode(reader, reader.uint32());
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine_BalanceSummary.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine_BalanceSummary();
		message.totalBalanceMoney = object.totalBalanceMoney !== undefined && object.totalBalanceMoney !== null ? Money.fromPartial(object.totalBalanceMoney) : undefined;
		message.currentMonthBalanceMoney = object.currentMonthBalanceMoney !== undefined && object.currentMonthBalanceMoney !== null ? Money.fromPartial(object.currentMonthBalanceMoney) : undefined;
		message.statementBalanceMoney = object.statementBalanceMoney !== undefined && object.statementBalanceMoney !== null ? Money.fromPartial(object.statementBalanceMoney) : undefined;
		message.minimumPaymentBalanceMoney = object.minimumPaymentBalanceMoney !== undefined && object.minimumPaymentBalanceMoney !== null ? Money.fromPartial(object.minimumPaymentBalanceMoney) : undefined;
		message.pastDueBalanceMoney = object.pastDueBalanceMoney !== undefined && object.pastDueBalanceMoney !== null ? Money.fromPartial(object.pastDueBalanceMoney) : undefined;
		message.availableBalanceMoney = object.availableBalanceMoney !== undefined && object.availableBalanceMoney !== null ? Money.fromPartial(object.availableBalanceMoney) : undefined;
		message.outstandingInterestBalanceMoney = object.outstandingInterestBalanceMoney !== undefined && object.outstandingInterestBalanceMoney !== null ? Money.fromPartial(object.outstandingInterestBalanceMoney) : undefined;
		message.outstandingPrincipalBalanceMoney = object.outstandingPrincipalBalanceMoney !== undefined && object.outstandingPrincipalBalanceMoney !== null ? Money.fromPartial(object.outstandingPrincipalBalanceMoney) : undefined;
		return message;
	}
};
function createBaseCreditLine_AutopaySettings() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine.AutopaySettings",
		enabled: undefined,
		paymentAmountType: undefined,
		paymentAmount: undefined,
		nextPaymentDate: undefined,
		paymentAccountToken: undefined
	};
}
export const CreditLine_AutopaySettings = {
	$type: "squareup.corporate_card.resources.CreditLine.AutopaySettings",
	encode(message, writer = new BinaryWriter()) {
		if (message.enabled !== undefined) {
			writer.uint32(8).bool(message.enabled);
		}
		if (message.paymentAmountType !== undefined) {
			writer.uint32(16).int32(message.paymentAmountType);
		}
		if (message.paymentAmount !== undefined) {
			Money.encode(message.paymentAmount, writer.uint32(26).fork()).join();
		}
		if (message.nextPaymentDate !== undefined) {
			writer.uint32(34).string(message.nextPaymentDate);
		}
		if (message.paymentAccountToken !== undefined) {
			writer.uint32(42).string(message.paymentAccountToken);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine_AutopaySettings();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.enabled = reader.bool();
					continue;
				}
				case 2: {
					if (tag !== 16) {
						break;
					}
					message.paymentAmountType = reader.int32();
					continue;
				}
				case 3: {
					if (tag !== 26) {
						break;
					}
					message.paymentAmount = Money.decode(reader, reader.uint32());
					continue;
				}
				case 4: {
					if (tag !== 34) {
						break;
					}
					message.nextPaymentDate = reader.string();
					continue;
				}
				case 5: {
					if (tag !== 42) {
						break;
					}
					message.paymentAccountToken = reader.string();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine_AutopaySettings.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine_AutopaySettings();
		message.enabled = object.enabled ?? undefined;
		message.paymentAmountType = object.paymentAmountType ?? undefined;
		message.paymentAmount = object.paymentAmount !== undefined && object.paymentAmount !== null ? Money.fromPartial(object.paymentAmount) : undefined;
		message.nextPaymentDate = object.nextPaymentDate ?? undefined;
		message.paymentAccountToken = object.paymentAccountToken ?? undefined;
		return message;
	}
};
function createBaseCreditLine_SmartRepaymentSettings() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine.SmartRepaymentSettings",
		optionalHoldRateBps: undefined,
		repaymentTarget: undefined
	};
}
export const CreditLine_SmartRepaymentSettings = {
	$type: "squareup.corporate_card.resources.CreditLine.SmartRepaymentSettings",
	encode(message, writer = new BinaryWriter()) {
		if (message.optionalHoldRateBps !== undefined) {
			writer.uint32(8).int32(message.optionalHoldRateBps);
		}
		if (message.repaymentTarget !== undefined) {
			CreditLine_SmartRepaymentSettings_RepaymentTarget.encode(message.repaymentTarget, writer.uint32(18).fork()).join();
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine_SmartRepaymentSettings();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.optionalHoldRateBps = reader.int32();
					continue;
				}
				case 2: {
					if (tag !== 18) {
						break;
					}
					message.repaymentTarget = CreditLine_SmartRepaymentSettings_RepaymentTarget.decode(reader, reader.uint32());
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine_SmartRepaymentSettings.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine_SmartRepaymentSettings();
		message.optionalHoldRateBps = object.optionalHoldRateBps ?? undefined;
		message.repaymentTarget = object.repaymentTarget !== undefined && object.repaymentTarget !== null ? CreditLine_SmartRepaymentSettings_RepaymentTarget.fromPartial(object.repaymentTarget) : undefined;
		return message;
	}
};
function createBaseCreditLine_SmartRepaymentSettings_RepaymentTarget() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine.SmartRepaymentSettings.RepaymentTarget",
		repaymentBalanceType: undefined,
		statementBalancePercent: undefined
	};
}
export const CreditLine_SmartRepaymentSettings_RepaymentTarget = {
	$type: "squareup.corporate_card.resources.CreditLine.SmartRepaymentSettings.RepaymentTarget",
	encode(message, writer = new BinaryWriter()) {
		if (message.repaymentBalanceType !== undefined) {
			writer.uint32(8).int32(message.repaymentBalanceType);
		}
		if (message.statementBalancePercent !== undefined) {
			writer.uint32(16).int32(message.statementBalancePercent);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine_SmartRepaymentSettings_RepaymentTarget();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.repaymentBalanceType = reader.int32();
					continue;
				}
				case 2: {
					if (tag !== 16) {
						break;
					}
					message.statementBalancePercent = reader.int32();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine_SmartRepaymentSettings_RepaymentTarget.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine_SmartRepaymentSettings_RepaymentTarget();
		message.repaymentBalanceType = object.repaymentBalanceType ?? undefined;
		message.statementBalancePercent = object.statementBalancePercent ?? undefined;
		return message;
	}
};
function createBaseCreditLine_PaymentAccount() {
	return {
		$type: "squareup.corporate_card.resources.CreditLine.PaymentAccount",
		isPrimary: undefined,
		bankInstitutionName: undefined,
		bankAccountNumberSuffix: undefined,
		token: undefined,
		accountType: undefined,
		balanceAmount: undefined,
		locationNickname: undefined
	};
}
export const CreditLine_PaymentAccount = {
	$type: "squareup.corporate_card.resources.CreditLine.PaymentAccount",
	encode(message, writer = new BinaryWriter()) {
		if (message.isPrimary !== undefined) {
			writer.uint32(8).bool(message.isPrimary);
		}
		if (message.bankInstitutionName !== undefined) {
			writer.uint32(18).string(message.bankInstitutionName);
		}
		if (message.bankAccountNumberSuffix !== undefined) {
			writer.uint32(26).string(message.bankAccountNumberSuffix);
		}
		if (message.token !== undefined) {
			writer.uint32(34).string(message.token);
		}
		if (message.accountType !== undefined) {
			writer.uint32(40).int32(message.accountType);
		}
		if (message.balanceAmount !== undefined) {
			Money.encode(message.balanceAmount, writer.uint32(50).fork()).join();
		}
		if (message.locationNickname !== undefined) {
			writer.uint32(58).string(message.locationNickname);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseCreditLine_PaymentAccount();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.isPrimary = reader.bool();
					continue;
				}
				case 2: {
					if (tag !== 18) {
						break;
					}
					message.bankInstitutionName = reader.string();
					continue;
				}
				case 3: {
					if (tag !== 26) {
						break;
					}
					message.bankAccountNumberSuffix = reader.string();
					continue;
				}
				case 4: {
					if (tag !== 34) {
						break;
					}
					message.token = reader.string();
					continue;
				}
				case 5: {
					if (tag !== 40) {
						break;
					}
					message.accountType = reader.int32();
					continue;
				}
				case 6: {
					if (tag !== 50) {
						break;
					}
					message.balanceAmount = Money.decode(reader, reader.uint32());
					continue;
				}
				case 7: {
					if (tag !== 58) {
						break;
					}
					message.locationNickname = reader.string();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return CreditLine_PaymentAccount.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseCreditLine_PaymentAccount();
		message.isPrimary = object.isPrimary ?? undefined;
		message.bankInstitutionName = object.bankInstitutionName ?? undefined;
		message.bankAccountNumberSuffix = object.bankAccountNumberSuffix ?? undefined;
		message.token = object.token ?? undefined;
		message.accountType = object.accountType ?? undefined;
		message.balanceAmount = object.balanceAmount !== undefined && object.balanceAmount !== null ? Money.fromPartial(object.balanceAmount) : undefined;
		message.locationNickname = object.locationNickname ?? undefined;
		return message;
	}
};
